<template>
  <div class="dp-chips">
    <div class="dp-chips__scroll" data-locator="qa-selected-docs-chips">
      <DocumentsPickerSelectedItem
        v-for="file in selected"
        :key="file.status ? `upload-${file.key}` : `${file.type}-${file.id}`"
        :file="file"
        layout="inline"
        locator-prefix="qa-selected-doc"
        @remove="$emit('remove', $event)"
      />
    </div>
  </div>
</template>

<script>
import DocumentsPickerSelectedItem from './DocumentsPickerSelectedItem.vue'

export default {
  name: 'DocumentsPickerSelectedChips',
  components: { DocumentsPickerSelectedItem },
  props: {
    selected: {
      type: Array,
      required: true,
    },
  },
  emits: ['remove'],
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.dp-chips {
  width: 100%;
}

.dp-chips__scroll {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 6px 2px;
  scrollbar-gutter: stable;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    @include border-radius('border-radius-3');
  }
}
</style>
